import React from "react";
import {
  ThreePointImagePosition,
  ThreePointsHighLighterDynamicZoneModel,
} from "@models/strapi-components/three-points";
import VizWrapper from "@components/common/Base/VizWrapper";
import { twMerge } from "tailwind-merge";
import Title from "@components/common/Title";
import ImageRenderer from "@components/common/Image";
import useIcons from "@hooks/use-source-icons";

export interface ThreePointHighlighterPropsModel {
  componentData: ThreePointsHighLighterDynamicZoneModel;
}
const ThreePointHighlighter: React.FunctionComponent<
  ThreePointHighlighterPropsModel
> = ({ componentData }) => {
  const { getFromReactIcons } = useIcons();
  const { title, subTitle, bgColor, imgPostion, threePointImage, tiles } =
    componentData;
  const wrapperClassName =
    ThreePointImagePosition.LEFT === imgPostion
      ? "flex-col lg:flex-row-reverse"
      : "flex-col lg:flex-row";

  const renderTiles = () => {
    return tiles?.map((tile) => {
      const { id, title, subTitle, icon } = tile;
      const Icon = getFromReactIcons(icon);
      return (
        <div
          key={id}
          className="flex items-center gap-6 mb-6 last:mb-0 max-w-[503px]"
        >
          <div className="p-2 rounded-full bg-white flex items-center justify-center">
            {Icon && <Icon size={28} />}
          </div>
          <div>
            <Title variant="h3" titleText={title} className="" />
            <Title variant="paragraph" titleText={subTitle} className="" />
          </div>
        </div>
      );
    });
  };
  return (
    <VizWrapper
      style={{ backgroundColor: bgColor ?? "#FFFFFF" }}
      className="px-8 xl:px-40"
    >
      <div
        className={twMerge(
          "flex items-center justify-start lg:justify-between gap-8",
          wrapperClassName
        )}
      >
        <div className="mb-8 lg:mb-0">
          <Title
            variant="h2"
            titleText={title}
            className="max-w-[533px] text-center mx-auto lg:ml-0 lg:text-left"
          />
          {subTitle && (
            <Title
              variant="paragraph"
              titleText={subTitle}
              className="max-w-[533px] text-center mx-auto lg:ml-0 lg:text-left"
            />
          )}
          <div className="pt-8">{renderTiles()}</div>
        </div>
        <div className="flex items-center justify-end xl:min-w-[550px]">
          <ImageRenderer image={threePointImage} alt={title} />
        </div>
      </div>
    </VizWrapper>
  );
};
export default ThreePointHighlighter;
